<template>
  <div class="dashboard">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-8 col-md-offset-2">
          <h1 class="page-header align-middle">Peer Pressure: The Writing App
            <img :src="user.avatarUrl() ? user.avatarUrl() : '/avatar-placeholder.png'" class="avatar">
            <small><span class="sign-out">(<a href="#" @click.prevent="signOut">Sign Out</a>)</span></small>
          </h1>
          <h2 class="user-info">
            <small>
              {{ user.name() ? user.name() : 'Nameless Person'}}'s Writing Desk
            </small>
            <small class="float-right">
            {{ user.username ? user.username : user.identityAddress }}
            </small>

          </h2>
          <form @submit.prevent="addWork" :disabled="! text">
            <div class="input-group">
              <input v-model="text" type="text" class="form-control" placeholder="Start your first assignment!" autofocus>
              <input v-model="goal" type="text" class="form-control" placeholder="100">
              <span class="input-group-btn">
                <button class="btn btn-default bg-light" type="submit" :disabled="! text">Add</button>
              </span>
            </div>
          </form>

          <ul class="list-group">
            <li v-for="work in works"
              class="list-group-item"
              :key="work.id">
              <label>
                Goal: {{work.goal}} characters
              </label>
              <p>{{ work.text }}</p>
              <a @click.prevent="writings.splice(writings.indexOf(work), 1)"
                class="delete float-right"
                href="#">X</a>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userSession } from '../userSession'
var FRIENDS_FILE = 'friends.json'
var WORKS_FILE = 'works.json'
export default {
  name: 'dashboard',
  props: ['user'],
  data () {
    return {
      friends: [],
      works: [],
      text: '',
      goal: '',
      uidCount: 0
    }
  },
  watch: {
    friends: {
      handler: function (friends) {
        // encryption is now enabled by default
        return userSession.putFile(FRIENDS_FILE, JSON.stringify(friends))
      },
      deep: true
    },
    works: {
      handler: function (works) {
        return userSession.putFile(WORKS_FILE, JSON.stringify(works))
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    addWork() {
      if (!this.text.trim()) {
        return
      }
      if (!this.goal.trim()) {
        this.goal = 100
      }
      this.works.unshift({
        id: this.uidCount++,
        text: this.text.trim(),
        goal: this.goal.trim()
      })
      this.goal = ''
      this.text = ''
    },

    // addTodo () {
    //   if (!this.todo.trim()) {
    //     return
    //   }
    //   this.todos.unshift({
    //     id: this.uidCount++,
    //     text: this.todo.trim(),
    //     completed: false
    //   })
    //   this.todo = ''
    // },

    fetchData () {
      userSession.getFile(WORKS_FILE) // decryption is enabled by default
        .then((worksText) => {
          var works = JSON.parse(worksText || '[]')
          works.forEach(function (work, index) {
            work.id = index
          })
          this.uidCount = works.length
          this.works = works
        }).then(userSession.getFile(FRIENDS_FILE))
        .then((friendsText) => {
          var friends = JSON.parse(friendsText || '[]')
          this.friends = friends
        })
    },

    signOut () {
      userSession.signUserOut(window.location.href)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dashboard {
  padding-top: 2rem;
}

input::placeholder {
  color: grey;
}

label {
  margin-bottom: 0;
  // width: 100%;
  cursor: pointer;
  input[type="checkbox"] {
    margin-right: 5px;
  }
}
.list-group-item {
  &.completed label {
    text-decoration: line-through;
  }

  .delete {
    display: none;
  }

  &:hover .delete {
    display: inline;
    color: grey;
    &:hover {
      text-decoration: none;
      color: red;
    }
  }
}
</style>
